import GeneralLedgerSettingsLayout from '@/modules/global-settings/general-ledger/layout/GeneralLedgerSettingsLayout.vue'

export default [
  {
    name: 'general-ledger',
    path: 'general-ledger',
    redirect: { name: 'primary-account-categories' },
    meta: {
      requiredPrivileges:  ['General Ledger Settings']
    },
    component: GeneralLedgerSettingsLayout,
    children: [
      {
        path: 'primary-account-categories',
        name: 'primary-account-categories',
        component: () =>
          import(
            '@/modules/global-settings/general-ledger/views/PrimaryAccountCategories.vue'
          )
      },
      {
        path: 'secondary-account-classes',
        name: 'secondary-account-classes',
        component: () =>
          import(
            '@/modules/global-settings/general-ledger/views/SecondaryAccountClasses.vue'
          )
      },
      {
        path: 'primary-account-classes',
        name: 'primary-account-classes',
        component: () =>
          import(
            '@/modules/global-settings/general-ledger/views/PrimaryAccountClasses.vue'
          )
      },
      {
        path: 'cost-centre-codes',
        name: 'cost-centre-codes',
        component: () =>
          import(
            '@/modules/global-settings/general-ledger/views/CostCentreCodes.vue'
          )
      },
      {
        path: 'financial-report-types',
        name: 'financial-report-types',
        component: () =>
          import(
            '@/modules/global-settings/general-ledger/views/FinancialReportTypes.vue'
          )
      },
      {
        path: 'bank-account-types',
        name: 'bank-account-types',
        component: () =>
          import(
            '@/modules/global-settings/general-ledger/views/BankAccountTypes.vue'
          )
      },
      {
        path: 'general-ledger-accounts',
        name: 'general-ledger-accounts',
        component: () =>
          import(
            '@/modules/global-settings/general-ledger/views/GeneralLedgerAccounts.vue'
          )
      },
    ]
  }
];
